<template>
    <v-card class="elevation-12">
        <v-toolbar dark color="primary">
            <v-toolbar-title>Add Team</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-form>
                <v-layout row wrap>
                    <v-text-field prepend-icon="people" v-model="teamName" label="Team Name" type="text"></v-text-field>
                    <v-layout row wrap>
                        <v-flex pl-3>
                            <v-text-field
                                    label=Year
                                    v-model=year
                                    type="number"
                            >
                            </v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex align-center class="text-xs-center" >
                            <v-radio-group row align-center v-model="season">
                                <v-radio label="W" value="W"></v-radio>
                                <v-radio label="S" value="S"></v-radio>
                                <v-radio label="F" value="F"></v-radio>
                            </v-radio-group>
                        </v-flex>
                    </v-layout>
                </v-layout>
                <v-layout row wrap>
                  <v-text-field v-model="handicapBasis" label="Handicap Basis" type="number" :rules="handicapBasisRules" required ref="handicapBasis"></v-text-field>
                </v-layout>
                <v-layout row wrap>
                  <v-text-field v-model="handicapPercentage" label="Handicap Percentage" type="number" :rules="handicapPercentageRules" required ref="handicapPercentage"></v-text-field>
                </v-layout>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-layout column>
                <v-btn color="primary" :disabled="isDisabled()" @click="submit" >Submit</v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
    import axios from "axios";
    export default {
      name: "add-season",
      data() {
        return {
          handicapBasisRules: [
            (v) => /^[0-9]+$/.test(v) || 'Must be between 0 and 300!',
            (v) => v <= 300 || "Too high!"
          ],
          handicapPercentageRules: [
            (v) => /^[0-9]+$/.test(v) || 'Must be between 0 and 100!',
            (v) => v <= 100 || "Too high!"
          ],
          season: null,
          teamName: null,
          handicapBasis: 225,
          handicapPercentage: 100,
          year: 2024,
          url: "https://nostyleguy.com/api/teams/"
        }
      },
      computed: {

      },
      methods: {
        isDisabled: function() {
          return ((this.$refs.handicapBasis && !this.$refs.handicapBasis.valid) ||
               (this.$refs.handicapPercentage && !this.$refs.handicapPercentage.valid));
        },
        submit: async function () {
          let payload = {
            name: this.teamName,
            year: this.year,
            season: this.season,
            hdcpBasis: this.handicapBasis,
            hdcpPercentage: (this.handicapPercentage / 100.0),
          };
          axios({
            method: "POST",
            url: this.url,
            data: payload,
            headers: {
              "content-type": "application/json"
            }
          }).then(
              result => {
                /* eslint-disable no-console */
                console.log(JSON.stringify(result.data))
                alert("Success!")
              },
              error => {
                /* eslint-disable no-console */
                console.error(error)
                alert(error)
              }
          );
        }
      }
    }
</script>

<style scoped>
.v-btn {
    min-width: 150px;
}
</style>